module.exports = require('./dist/home-calculator-profile');
